import formatNumber from '@/utils/NumberFormatter';
import Validatable from '@/validator/Validatable';

interface ISummarizedReportUnitAPI {
  id: number;
  name: string;
  site_id: number;
  latitude: number;
  longitude: number;
  impressions: number[];
  revenue: number[];
  cpm: number[];
  external_id: string;
  media_owner: string;
}

export default class SummarizedReportUnit extends Validatable {
  name: string;
  siteID: number;
  latitude: number;
  longitude: number;
  impressions: number[];
  revenue: number[];
  cpm: number[];
  externalId: string;
  mediaOwner: string;

  apiObject: ISummarizedReportUnitAPI;

  constructor(
    id = -1,
    name = null,
    siteID = null,
    latitude = null,
    longitude = null,
    impressions = null,
    revenue = null,
    cpm = null,
    externalId = null,
    mediaOwner = null,
  ) {
    super();
    this.id = id;
    this.name = name;
    this.siteID = siteID;
    this.latitude = latitude;
    this.longitude = longitude;
    this.impressions = impressions;
    this.revenue = revenue;
    this.cpm = cpm;
    this.externalId = externalId;
    this.mediaOwner = mediaOwner;
  }

  get totalImpressions() {
    return this.impressions.reduce((mem, x) => {
      return mem + x;
    }, 0);
  }

  get totalImpressionsFormatted() {
    return formatNumber(this.totalImpressions, '0,0');
  }

  get totalRevenue() {
    return this.revenue.reduce((mem, x) => mem + x, 0);
  }

  get avgCPM() {
    return this.cpm.reduce((mem, x) => mem + x / this.cpm.length, 0);
  }

  static fromApi(apiObject) {
    const entity = new SummarizedReportUnit(
      apiObject.id,
      apiObject.name,
      apiObject.site_id,
      apiObject.latitude,
      apiObject.longitude,
      apiObject.impressions,
      apiObject.revenue,
      apiObject.cpm,
      apiObject.external_id !== undefined ? apiObject.external_id : null,
      apiObject.media_owner !== undefined ? apiObject.media_owner : null,
    );
    entity.apiObject = apiObject;
    return entity;
  }

  static fromObject(obj) {
    return super.fromObject(obj, new SummarizedReportUnit());
  }

  static validatorCreateRules() {
    return {};
  }
}
